import { takeEvery, select, put } from 'redux-saga/effects';
import { selectPharmaciesList } from '../selectors';
import {
  consts as pharmacyConsts,
  actions as pharmacyActions,
} from '../requests/pharmacy-req';

function* loadMoreWorker(action) {
  const { payload } = action;
  const { zip, activeMailOrder, offset } = payload;

  const limit = 20;
  const pharmaciesList = yield select(selectPharmaciesList);

  if (offset >= pharmaciesList.count) {
    return;
  }

  yield put(
    pharmacyActions.send({
      ...(activeMailOrder && { mailOrder: true }),
      limit,
      zip,
      offset: offset + limit,
    }),
  );
}

export default function* PharmacyMoreSaga() {
  yield takeEvery([pharmacyConsts.LOAD_MORE], loadMoreWorker);
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/more-pharmacies-saga.js